import { Outlet, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import useAxiosPrivate from '../../auth_services/useAxiosPrivate';
import { CircularProgress, Box, IconButton, Tooltip, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Logout } from '@mui/icons-material';
import Leftmenu from './menu/Leftmenu';
import Appbar from './Appbar';
import useAuth from '../../auth_services/useAuth';
import AlertPopup from '../../components/modal/AlertPopup';
import mqttClient from '../../api/mqtt.js';
import '../../css/table_style.css';

import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import CurrencyFormat from 'react-currency-format';

const MainLayoutOld = () => {
    const navigate = useNavigate();
    // setOutletContext for set attribute value from route children element
    const [outletContext, setOutletContext] = useState("");
    const location = useLocation();

    // Check login for loading page
    const [loading, setLoading] = useState(false);
    const axiosPrivate = useAxiosPrivate();

    // Set alert props
    const [alertPopup, setAlertPopup] = useState({ open: false });

    const [menuSmall, setMenuSmall] = useState('large');
    const [merchantVal, setMerchantVal] = useState(''); // Set contain date update from merchant info
    const [profileupdate, setProfileupdate] = useState(''); // Set contain date update from profile update

    // Notification
    const [prdOutofStockCount, setPrdOutofStockCount] = useState('');
    const [prdExpireSoonCount, setPrdExpireSoonCount] = useState('12');

    useEffect(() => {
        checkLogin();
        const leftMenuResize = localStorage.getItem("leftMenuResize");
        if (leftMenuResize != null) {
            setMenuSmall(leftMenuResize);
        }
    }, []);


    // Mqtt broker listen
    const [mqttMessage, setMqttMessage] = useState([]);
    useEffect(() => {
        mqttClient.on('connect', () => {
            mqttClient.subscribe('salePaymentSuccess');
            mqttClient.subscribe('packagePaymentSuccess');
        });
        mqttClient.on('message', (topic, message) => {
            //console.log('topic, message', topic, message.toString());
            let message1 = message.toString();
            let message2 = JSON.parse(message1);
            let data = message2.val;

            if (data.mid == useAuth.mid()) {
                // Sale payment
                let action = '';
                if (topic == 'salePaymentSuccess') {
                    action = 'salePaymentSuccess';
                }
                // Package payment
                else if (topic == 'packagePaymentSuccess') {
                    action = 'packagePaymentSuccess'
                }

                setMqttMessage({
                    action: action,
                    val: data
                });

                // Set sms count to localStorage
                let count = 0;
                if (localStorage.getItem("smscount") != undefined && localStorage.getItem("smscount") != null) {
                    let smsCount = JSON.parse(localStorage.getItem("smscount"));
                    count = parseInt(smsCount.count + 1);
                }
                let sms = {
                    mid: useAuth.mid(),
                    count: count
                }
                localStorage.setItem("smscount", JSON.stringify(sms));
            }

        });

        mqttClient.on('error', (err) => {
            //console.error('Connection error: ', err);
        });

        mqttClient.on('close', (close) => {
            //console.error('Connection close: ', close);
        });

        return () => {
            //mqttClient.end();
        };

    }, []);


    const checkLogin = async () => {
        try {
            if (useAuth.checkPermissionNull()) {
                await axiosPrivate.get('authtoken');
                setLoading(false);
            } else {
                useAuth.Logout();
                navigate("/login");
            }

        } catch (error) {
            console.log('error', error);
        }
    }

    const logout = async () => {
        try {
            useAuth.Logout();
            navigate("/login");
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        GetMerchantInfo();
    }, [location.pathname]);
    // Update merchant data when merchant infor change
    const GetMerchantInfo = async () => {
        try {
            const mid = useAuth.mid();
            const response = await axiosPrivate.get(`merchant_info/${mid}`);
            setMerchantVal(response.data);
            localStorage.setItem("mm", JSON.stringify(response.data));

            if (response.data.status != 'active') {
                setAlertPopup({
                    open: true,
                    status: 'warning',
                    message: 'ຮ້ານຄ້າຂອງທ່ານມີສະຖານະ ' + response.data.status,
                    message_detail: 'ກະລຸນາຕິດຕໍ່ພົວພັນກັບ admin',
                    btn: {
                        btnAction1: {
                            status: true,
                            txt: 'ຕົກລົງ',
                            func: async () => {
                                setAlertPopup({ open: false });
                                logout();
                            }
                        }
                    }
                });
            }
        } catch (error) {
            // Check login authen
            if (error.response?.status == '401') {
                navigate('/login');
            }
        }
    }

    useEffect(() => {
        ScreenWidth(window.innerWidth);
        const handleResize = () => ScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const ScreenWidth = (widthSize) => {
        if (widthSize < '1400') {
            localStorage.setItem("leftMenuResize", 'small');
            setMenuSmall('small');
        }
    }

    const [open, setOpen] = useState(false);
    const handleClick = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    // Mqtt broker listen
    const [paymentSuccessAlert, setPaymentSuccessAlert] = useState(false);
    const [paymentSuccess, setPaymentSuccess] = useState({
        status: 'bill_payment',
        bill_id: '',
        bill_no: '',
        total_amount_lak: 0,
        total_amount: 0,
        total_amount_currency: '',
        total_amount_currency_name: '',
        pay_amount: 0,
        currency: '',
        currency_name: '',
        rate: '',
        change_amount: 0,
        change_amount_lak: 0,
        payment_method: 'Cash'
    });
    useEffect(() => {
        if (mqttMessage.action == 'salePaymentSuccess') {
            setPaymentSuccess(mqttMessage.val);
            setPaymentSuccessAlert(true);
        }

        if (mqttMessage.action == 'packagePaymentSuccess') {
            setPaymentSuccess(mqttMessage.val);
            setPaymentSuccessAlert(true);
        }

    }, [mqttMessage]);

    // Loading
    if (loading) {
        return (
            <Box sx={{ display: 'flex' }}>
                <CircularProgress className='tyLoadingPosition' />
            </Box>
        )
    }

    // Main layout show
    return (
        <>
            {useAuth.checkRole() == true &&
                <Snackbar
                    open={paymentSuccessAlert}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    autoHideDuration={3000}
                    onClose={() => setPaymentSuccessAlert(false)}
                >
                    <Alert
                        onClose={handleClose}
                        severity="success"
                        color={paymentSuccess.status == 'bill_payment' ? "success" : "info"}
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        <Box sx={{ fontWeight: '600' }}>{paymentSuccess.msg}</Box>
                        <Box sx={{ fontWeight: '300', fontSize: '12px', minWidth: '200px' }}>
                            {paymentSuccess.status == 'bill_payment' ? (
                                <>BillNo: {paymentSuccess.bill_no}</>
                            ) : (
                                <>{paymentSuccess.package}</>
                            )}
                        </Box>
                        <Box sx={{ fontWeight: '600' }}>
                            <CurrencyFormat
                                value={paymentSuccess.total_amount_lak}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={''}
                                suffix={'  ກິບ'}
                            />
                        </Box>
                    </Alert>
                </Snackbar>
            }

            <Box sx={{ flexGrow: 1 }}>
                <Appbar
                    mainMenuActive={outletContext.mainMenuActive}
                    menuActive={outletContext.menuActive}
                    pageTitle={outletContext.pageTitle}
                    prdOutofStockCount={prdOutofStockCount}
                    prdExpireSoonCount={prdExpireSoonCount}
                    setMenuSmall={setMenuSmall}
                    menuSmall={menuSmall}
                    merchantVal={merchantVal}
                    profileupdate={profileupdate}
                    mqttMessage={mqttMessage}
                />
                <Box sx={{
                    display: 'flex',
                    width: '100%'
                }}>
                    <Box position="fixed">
                        <Box
                            component="nav"
                            sx={{
                                marginTop: '0px',
                                width: (menuSmall == 'large') ? '250px' : '80px',
                                //transition: 'width 0.5s',
                                height: "calc(100vh - 60px)",
                                display: { xs: 'none', md: 'block' },
                                overflowY: 'auto',
                                backgroundColor: 'background.leftmenu',
                                //borderRight: '1px solid',
                                //borderRightColor: 'boderColor.default',
                                zIndex: '1100',
                                '@media screen and (max-width: 1400px)': {
                                    width: '80px',
                                },
                            }}
                        >
                            <Leftmenu
                                drawerStatus='no'
                                mainMenuActive={outletContext.mainMenuActive}
                                menuActive={outletContext.menuActive}
                                menuStatus={menuSmall}
                                prdOutofStockCount={prdOutofStockCount}
                                prdExpireSoonCount={prdExpireSoonCount}
                                merchantVal={merchantVal}
                            />
                        </Box>

                        <Box sx={{
                            width: (menuSmall == 'large') ? '250px' : '80px',
                            padding: (menuSmall == 'large') ? '8px 0px 13px 20px' : '5px 0px 13px 12px',
                            marginTop: '0px',
                            backgroundColor: 'background.leftmenu',
                            display: { xs: 'none', md: 'block' },
                            borderStyle: 'solid',
                            borderWidth: '1px 0px 0px 0px',
                            borderColor: 'boderColor.default',
                            fontSize: '14px'
                        }} >
                            <Tooltip title='ອອກຈາກລະບົບ'>
                                <IconButton
                                    size="large"
                                    aria-label="show 17 new notifications"
                                    color="inherit"
                                    sx={{ display: (menuSmall == 'large') ? 'none' : 'show' }}
                                    onClick={logout}
                                >
                                    <Logout sx={{ fontSize: '20px' }} />
                                </IconButton>
                            </Tooltip>
                            <Button
                                variant="text"
                                sx={{ color: 'text.default', display: (menuSmall == 'large') ? 'show' : 'none' }}
                                startIcon={<Logout sx={{ fontSize: '20px' }} />}
                                onClick={logout}
                            >
                                ອອກຈາກລະບົບ
                            </Button>
                        </Box>
                    </Box>

                    <Box sx={{ minWidth: (menuSmall == 'large') ? '210px' : '40px', display: { xs: 'none', md: 'block' } }} />
                    <Box
                        component="main"
                        position="static"
                        sx={{
                            height: "calc(100vh - 10%)",
                            flexGrow: 1,
                            overflowY: 'auto',
                            justifyContent: 'center',
                            alignItems: 'center',
                            //marginTop: '70px',
                            marginTop: '60px',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            //width: '600px',
                            padding: "30px 30px 0px 50px",
                            '@media screen and (max-width: 900px)': {
                                padding: "0px 20px 0px 20px",
                            },
                        }}
                    >
                        <Outlet
                            context={{
                                setOutletContext,
                                setPrdExpireSoonCount,
                                setPrdOutofStockCount,
                                prdOutofStockCountSoon: prdOutofStockCount,
                                prdExpireSoonCount,
                                setMenuSmall,
                                menuSmall,
                                merchantVal,
                                setMerchantVal,
                                setProfileupdate,
                                mqttMessage
                            }}
                        />
                    </Box>
                </Box >
            </Box >

            {/***  Modal popup alert*/}
            <AlertPopup
                width='400px'
                props={alertPopup}
            />

        </>
    )

}

export default MainLayoutOld